import React, {useEffect, useState} from "react";
import "./PrivacyPolicy.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import {getAssetPath} from "../../services/helpers";
import {useNavigate} from "react-router-dom";

import {getLocalStorageData, storeData} from "../../services/localStorageService";

const PrivacyPolicy = () => {

    return (
        <>
            <main className="main_wrapper terms-page">
       <div className="inn-ban" style={{marginBottom:50}}>
            <div className="container">
                <div className="row">
                    <h1>Privacy Policy</h1>
                </div>
            </div>
        </div>
        
        <div className="container">
        {/* Introduction */}
        <div className="terms-div" id="introduction">
          <h2 className="div-title">WHAT DO WE DO WITH YOUR INFORMATION?</h2>

          <p>When you pay for a service/donate something via our electronic platforms, such as our website or app, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.
When you browse our online services, we also automatically receive your computer’s Internet Protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.
Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.
</p>
        </div>

        <div className="terms-div" id="eligibility">
          <h2 className="div-title">
             CONSENT
          </h2>
          <h3>How do you get my consent?</h3>
          <p>
           When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.
If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your explicit consent, or provide you with an opportunity to say no.

          </p>
 <h3> <h3>How do you get my consent?</h3></h3>
          <p>
           If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at any time, by contacting us at <a href="mailto:support@vikasmandalmulund.com">
  support@vikasmandalmulund.com
</a>.
          </p>

        </div>

        <div className="terms-div" id="mobile-app-terms">
          <h2 className="div-title">
          DISCLOSURE
          </h2>

          <p>
            We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
          </p>

        </div>

        <div className="terms-div" id="third-party">
          <h2 className="div-title">
            PAYMENT
          </h2>

          <p>
           We use Razorpay as the payment gateway for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
          </p>

          <p>
           Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express, Discover and RuPay.
          </p>

          <p>PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.</p>
          <p>For more insight, you may also want to read Razorpay’s terms and conditions on  <a
  href="https://razorpay.com"
  target="_blank"
  rel="noopener noreferrer"
>
  https://razorpay.com
</a></p>
        </div>

        <div className="terms-div" id="terms-use">
          <h2 className="div-title">
            THIRD-PARTY SERVICES
          </h2>

          <p>
            In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
          </p>

          <p>
           However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.
          </p>

          <p>
            For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
          </p>

          <p>
            In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
          </p>
<p>Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.</p>
<p>Links
When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.
</p>
        </div>
        

        <div className="terms-div" id="termination">
          <h2 className="div-title">
           SECURITY
          </h2>

          <p>
            To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
          </p>

          
        </div>

        <div className="terms-div" id="ownership-rights">
          <h2 className="div-title">
            COOKIES
          </h2>

          <p>
           We use cookies to maintain your user session. They are not used to personally identify you on other websites.
          </p>

          
        </div>


        <div className="terms-div" id="content-rights">
          <h2 className="div-title">
           AGE OF CONSENT
          </h2>

          <p>
           By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
          </p>

        </div>


        <div className="terms-div" id="copyright-policy">
          <h2 className="div-title">
           CHANGES TO THIS PRIVACY POLICY
          </h2>

          <p>
            We reserve the right to modify this Privacy Policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
          </p>

          <p>
            If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.
          </p>

        </div>


          <div className="terms-div" id="member-disputes">
            <h2 className="div-title">
             QUESTIONS AND CONTACT INFORMATION
            </h2>

            <p>
             If you would like to access, correct, amend, or delete any personal information we have about you, register a complaint, or simply want more information, contact our Privacy Compliance Officer at <a href="mailto:support@vikasmandalmulund.com">

  support@vikasmandalmulund.com

</a>
            </p>

           
          </div>

          </div>
      </main>
        </>
    );
};

export default PrivacyPolicy;
